import { FieldDisplayType } from './field-display-type';
import { FilterField } from './filter-field';
import { FieldValue } from './field-value';
import { SavedFilterFieldFactory } from './saved-filter-field';
import { FilterComparerGuids } from './filter-comparer-guids';

export class AdvancedFieldValue extends FieldValue {
    /** Comparer used for this filter value.
     *  e.g. is, is not, contains, etc.
     */
    comparer: string;

    /** Number of fields in this group.
     *  Only set on first field of group.
     */
    groupLength?: number;

    /** Whether or not this group has NOT enabled.
     *  Only set on first field of group.
     */
    groupNot?: boolean;

    /** GUID representing this group.
     *  Set on every field in this group.
     */
    group?: string;

    /** How many columns the field title needs to span.
     *  Set on all fields.
     */
    titleColspan?: number;

    constructor(field: FilterField, group?: string) {
        super(field);
        this.comparer = field.comparers && field.comparers.length > 0 ? field.comparers[0].value : null;
        this.group = group;
        if (field.displayType === FieldDisplayType.Boolean || field.displayType === FieldDisplayType.CustomCodingCheckbox || field.displayType === FieldDisplayType.CustomCodingSharedCheckbox) this.value = [true];
    }

    static fromSimple(field: FieldValue): AdvancedFieldValue {
        const afv = new AdvancedFieldValue(field.field);
        afv.comparer = SavedFilterFieldFactory.createFromSimple(field).comparer;

        // all three bates fields filled out in the simple filter means 'between' for advanced
        if (afv.field.displayType === FieldDisplayType.Bates && field.value[0] && field.value[1] && field.value[2]) afv.comparer = FilterComparerGuids.Between;

        if (afv.comparer === FilterComparerGuids.Before) {
            // 'before' values are put in the value array at index 1 in the simple filter and index 0 in the advanced
            afv.value.push(field.value[1]);
        } else if (afv.field.displayType === FieldDisplayType.Bates && !field.value[1] && field.value[2]) {
            // end number but no start number means 'is' for simple filter
            // 'is' for the advanced filter only has two values
            afv.value[0] = field.value[0];
            afv.value[1] = field.value[2];
        } else {
            afv.value = field.value;
        }

        return afv;
    }
}
